<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">Playlist</h2>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>
          Add Playlist
        </span>
      </base-button>
    </div>
    <PlaylistTable />
  </b-card>
</template>

<script>
import PlaylistTable from "./components/playlistTable.vue";
export default {
  components: {
    PlaylistTable,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "add-playlist" });
    },
  },
  async mounted() {
    await this.$store.dispatch("playlist/getall_category");
  },
};
</script>
<style></style>
